// SearchTypeCategory.jsx
'use strict';
import React from 'react';

import UniversalContainer from '../component/UniversalContainer.jsx';
import prepareSearchPageMeta from '../resource/prepareSearchPageMeta.js';
import { searchType } from '../resource/searchConstants.js';
import { createInitialStoreWithRequest } from '../createInitialStore.js';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { useLoaderData } from 'react-router';
import { getI18nInstance } from '../resource/i18n.js';
import { generateLangPath } from '../resource/langPath.js';

/**
 * Loader for search type category pages
 * Generates SEO meta tags and JSON-LD for SearchResultsPage with category filter
 */
export const loader = async ({ request, params }) => {
  const { type = searchType.ALL, category = null } = params;
  const url = new URL(request.url);
  const query = url.searchParams.get('q') || '';
  const hostname = url.hostname || 'swag.live';

  // Get Redux store
  const { store } = await createInitialStoreWithRequest({
    params,
    request,
  });
  const state = store.getState();
  const { i18n } = getI18nInstance();
  const currentLanguage = i18n.language;
  const langPath = generateLangPath(`/${currentLanguage}`, currentLanguage);

  // Build canonical URL
  const canonical = `https://${hostname}${langPath}/search/${type}/${category}${query ? `?q=${encodeURIComponent(query)}` : ''}`;

  // Prepare meta tags with JSON-LD
  const meta = await prepareSearchPageMeta({
    state,
    query,
    type,
    category,
    hostname,
    includeJsonLd: true,
    canonical,
  });

  return {
    meta,
    params,
    staticContext: {
      requestHeaders: {
        hostname,
      },
    },
  };
};

const SearchTypeCategoryRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();
  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalContainer filename="Search" />
    </>
  );
};

export default SearchTypeCategoryRoute;
